export default "__VITE_PUBLIC_ASSET__caaa6422__"